import { AbsoluteCenter, Box, Text } from "@chakra-ui/react";
import { specialTextGradientStyle } from "../../utils/specialTextGradientStyle";

const tag_color = (tag_name) => {
  const lower_tag_name = tag_name?.toLowerCase();
  switch (lower_tag_name) {
    case "hot":
      return "linear(to-b, #EA3B19,#D22E16, #A61515)";
    case "new":
      return "linear(to-b, green-700, green.400)";
    default:
      return "linear(to-b, #EA3B19,#D22E16, #A61515)";
  }
};
const exceptionTags = ["long"];

const GameTag = ({ game_tags_props = [], isLongLayout } = {}) => {
  const filterTags = game_tags_props?.filter((tag) => {
    const split_tag = tag?.split("_");
    const tag_name = split_tag?.[0];
    return !exceptionTags.includes(tag_name);
  });

  return (
    <AbsoluteCenter
      position={`absolute`}
      // top={{
      //   base: "5px",
      //   lg: "15px",
      // }}
      // right={{
      //   base: "5px",
      //   lg: "10px",
      // }}
      top={isLongLayout ? "40px" : "30px"}
      zIndex={`10`}
      display="flex"
      gap="5px"
      w="100%"
      justifyContent={"center"}
      alignItems={"center"}
    >
      {filterTags?.map((tag) => {
        const split_tag = tag?.split("_");
        const tag_name = split_tag?.[0];
        const tag_number = split_tag?.[1];

        const bgColor = tag_color(tag_name);

        return (
          <Box
            p="3px"
            borderRadius={`full`}
            bgGradient={"linear(to-b,#FDEEB8,#E1972F)"}
          >
            <Box
              gap="2.5px"
              minW={`55px`}
              py={{
                base: "2.5px",
                md: "1px",
              }}
              px="15px"
              borderRadius={`full`}
              alignItems={`center`}
              justifyContent={`center`}
              fontWeight={`bold`}
              color="white"
              bgGradient={bgColor}
              display="flex"
            >
              <Text
                as="span"
                sx={{
                  ...specialTextGradientStyle,
                  WebkitTextStroke: "1px #670026",
                  textStroke: "1px #670026",
                  background: "#fdf2a9",
                  fontWeight: 900,
                }}
                fontSize={{
                  base: "sm",
                  md: isLongLayout ? `25px` : `18px`,
                }}
                letterSpacing={`tighter`}
              >
                {tag_name?.toUpperCase()} {tag_number}
              </Text>
            </Box>
          </Box>
        );
      })}
    </AbsoluteCenter>
  );
};

export default GameTag;
